var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Profile_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9887 5.79105C13.9887 8.72808 11.6338 11.0831 8.6947 11.0831C5.7566 11.0831 3.40072 8.72808 3.40072 5.79105C3.40072 2.85402 5.7566 0.5 8.6947 0.5C11.6338 0.5 13.9887 2.85402 13.9887 5.79105ZM8.6947 20.5C4.35708 20.5 0.694702 19.795 0.694702 17.075C0.694702 14.3539 4.38008 13.6739 8.6947 13.6739C13.0333 13.6739 16.6947 14.3789 16.6947 17.099C16.6947 19.82 13.0093 20.5 8.6947 20.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e44e3bf8f6463b59be3f216cc0736114.svg";
export { ForwardRef as ReactComponent };